import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Observable } from "rxjs";
import { GridColumnMeta } from "src/app/ant-grid-custom/ant-grid-custom-model";
import { AntGridCustomComponent } from "src/app/ant-grid-custom/ant-grid-custom.component";
import { Dictionary } from "src/app/store/models/common_types";
import { AlertSettingsPageDataService } from "../alert-settings-page-data.service";
import { alertTypeEnum } from "../alert-settings-page.model";

@Component({
  selector: "app-alert-settings-grid-wrapper",
  templateUrl: "./alert-settings-grid-wrapper.component.html",
  styleUrls: ["./alert-settings-grid-wrapper.component.scss"],
  host: { class: "alert-setting-grid-component" },
})
export class AlertSettingsGridWrapperComponent implements OnInit, OnChanges {
  legacyUrl = `${window.caUrl}/app`;
  columnsData: GridColumnMeta[][];
  columnFields: any[];
  dataToUse: {};
  processedData: any[];
  dataSet = false;
  hasError = false;
  selectedRows;
  totalResultCount;
  pageIndex;
  pageSize = 24;
  errorMsg = "Something went wrong!";
  dataObservable: Observable<any | any>;
  @Input() selectedCompany;
  @Output() selectedRowsChange: EventEmitter<any> = new EventEmitter();
  @Output() alertCompanyDataSet: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteClicked: EventEmitter<any> = new EventEmitter();
  @Input() selectedTab: string;
  @ViewChild(AntGridCustomComponent)
  antGridComp: AntGridCustomComponent;
  //checkbox for watchlist
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  isFrontPagination = false;
  listOfDisplayData: Array<any> = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  mapOfSort: { [key: string]: string | null } = {};
  listOfCheckedData: Array<any> = [];
  currentSort: any;
  constructor(private dataService: AlertSettingsPageDataService) {
    this.columnFields = [
      {
        field: "companyname",
        renderer: null,
      },
      {
        field: "ticker",
        renderer: null,
      },
      {
        field: "alerts",
        renderer: null,
      },
      {
        field: "notification",
        renderer: null,
      },
      {
        field: "actions",
        renderer: "alert-grid-action",
      },
      {
        field: "enable",
        renderer: "checkbox",
      },
    ];
    this.columnsData = [
      [
        {
          children: 1,
          header: "Company",
          sortKey: "companyname",
          showSort: true,
          showFilter: false,
        },
        {
          children: 1,
          header: "Ticker",
          sortKey: "ticker",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Alerts",
          sortKey: "alerts",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Notification Option",
          sortKey: "notification",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Actions",
          sortKey: "actions",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Enable",
          sortKey: "enable",
          showSort: false,
          showFilter: false,
        },
      ],
    ];
    this.pageIndex = 1;
  }

  ngOnInit() {
    this.dataObservable = this.dataService.getCompanyAlerts();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.selectedTab &&
      changes.selectedTab.currentValue !== changes.selectedTab.previousValue
    ) {
      this.selectedTab = changes.selectedTab.currentValue;
      this.dataSet = false;
      this.dataObservable =
        this.selectedTab === "company"
          ? this.dataService.getCompanyAlerts()
          : this.dataService.getWatchlistAlerts();
    }
    if (
      changes.selectedCompany &&
      changes.selectedCompany.currentValue === null
    ) {
      // when clear icon is clicked in company search box
      this.dataToUse = { ...this.dataToUse, processedData: this.processedData };
    } else if (
      changes.selectedCompany &&
      changes.selectedCompany.currentValue !==
        changes.selectedCompany.previousValue
    ) {
      //show filtered values only
      const data = this.processedData.filter(
        (obj) => obj.ticker === changes.selectedCompany.currentValue,
      );
      this.totalResultCount = data.length;
      this.dataToUse = {
        ...this.dataToUse,
        processedData: data,
        totalCount: this.totalResultCount,
      };
    }
  }
  onDataResolved(response) {
    if (response.status === "error") {
      this.processedData = [];
      this.totalResultCount = 0;
    } else {
      this.totalResultCount = response.alerts.length;
      if (this.selectedTab === "company") {
        this.processedData = this.formatData(response.alerts);
        this.dataToUse = {
          showCheckbox: true,
          showCheckboxHeader: true,
          columnsData: this.columnsData,
          fields: this.columnFields,
          processedData: this.processedData,
          selectedRows: this.selectedRows,
          totalCount: this.totalResultCount,
          widthConfig: [
            "30%", //company
            "150px", //ticker
            "25%", //alerts
            "auto", //notification
            "100px", //alerts
            "50px", //enable
          ],
          gridHeight: "calc(100vh - 350px)", // height calculated as per screen height - top
          bordered: false,
          count: this.totalResultCount,
          pageIndex: this.pageIndex,
          isFrontPagination: false,
          pageSize: this.pageSize,
          pageSizeOptions: [12, 24, 48, 96],
          showTotalCount: true,
        };

        const alertCompanyData = this.processedData.map((val) => {
          return { companyName: val.companyname, ticker: val.ticker };
        });
        this.alertCompanyDataSet.emit(alertCompanyData);
      } else {
        this.processedData = this.formatWatchlistData(response.alerts);
        const fields = [
          "watchlist",
          "alerts",
          "notification",
          "actions",
          "enable",
        ];
        this.listOfDisplayData = this.processedData.slice();
        for (const key in fields) {
          this.mapOfSort[key] = null;
        }
      }
    }
    this.hasError = false;
    this.dataSet = true;
  }
  formatData(data) {
    const processedData = [];
    data.forEach((element) => {
      const alertsType = element.alert_event_types.map(
        (val) => val.display_name,
      );

      const rowObj = {
        companyname: element.alert_items[0].item_object_full_name,
        ticker: element.alert_items[0].item_object_short_name,
        alerts: alertsType.join(", "),
        notification: element.frequency.join(", "),
        actions: {
          id: element.alert_items[0].item_object_short_name,
          alertId: element.id,
          type: alertTypeEnum.company,
          name: element.alert_items[0].item_object_short_name,
          onDelete: this.deleteAlerts.bind(this),
          onEdit: this.reloadGrid.bind(this),
        },
        enable: {
          checked: element.is_enable,
          text: "",
          value: element.id,
          callUpdateCallback: this.enableCheckBoxChange.bind(this),
        },
        id: element.id,
      };
      processedData.push(rowObj);
    });
    return processedData;
  }
  enableCheckBoxChange(data) {
    const params = {
      alert_id: data.value,
      status: data.checked,
    };
    this.dataService.putEnable(params).subscribe();
  }
  formatWatchlistData(data) {
    const processedData = [];
    data.forEach((element) => {
      const alertsType = element.alert_event_types.map(
        (val) => val.display_name,
      );

      const rowObj = {
        watchlistName:
          element.alert_items[0].item_object_full_name.watcher_name,
        alerts: alertsType.join(", "),
        notification: element.frequency.join(", "),
        enable: {
          checked: element.is_enable,
          text: "",
          value: element.id,
          callUpdateCallback: this.enableCheckBoxChange.bind(this),
        },
        actions: {
          id: element.alert_items[0].itemObjectId,
          alertId: element.id,
          type: alertTypeEnum.watchlist,
          name: element.alert_items[0].item_object_full_name.watcher_name,
          onDelete: this.deleteAlerts.bind(this),
          onEdit: this.reloadGrid.bind(this),
        },
        id: element.id,
        expand: false,
        children: element.alert_items[0].item_object_full_name.companies,
      };
      processedData.push(rowObj);
    });
    return processedData;
  }
  onSortChange(sortData: Dictionary<any>) {
    // sort logic
    if (sortData.value === "ascend") {
      this.processedData = this.processedData.sort((a, b) => {
        return a.companyname < b.companyname ? -1 : 1;
      });
    } else {
      this.processedData = this.processedData.sort((a, b) => {
        return a.companyname > b.companyname ? -1 : 1;
      });
    }
    this.currentSort = sortData;
    this.dataToUse = {
      ...this.dataToUse,
      processedData: this.processedData,
    };
  }
  getSelectedRows(selectedRows: Array<any>) {
    this.selectedRows = selectedRows;
    this.selectedRowsChange.emit(this.selectedRows);
  }
  refreshStatus(): void {
    this.isAllDisplayDataChecked = this.listOfDisplayData
      .filter((item) => !item.selectionDisabled)
      .every((item) => this.mapOfCheckedId[item.id]);
    this.isIndeterminate =
      this.listOfDisplayData
        .filter((item) => !item.selectionDisabled)
        .some((item) => this.mapOfCheckedId[item.id]) &&
      !this.isAllDisplayDataChecked;
    this.listOfCheckedData = this.listOfDisplayData.filter(
      (item) => this.mapOfCheckedId[item.id],
    );
    this.selectedRowsChange.emit([this.listOfCheckedData]);
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData
      .filter((item) => !item.selectionDisabled)
      .forEach((item) => (this.mapOfCheckedId[item.id] = value));
    this.refreshStatus();
  }
  reloadGrid() {
    if (this.selectedTab === "company") {
      this.dataService.getCompanyAlerts().subscribe((resp) => {
        this.onDataResolved(resp);
      });
    } else {
      this.dataService.getWatchlistAlerts().subscribe((resp) => {
        this.onDataResolved(resp);
      });
      this.checkAll(false);
    }
  }
  deleteAlerts(data) {
    this.onDeleteClicked.emit(data);
  }
  paginationChanged(pageIndex, pageSize) {
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;
    const start = (pageIndex - 1) * pageSize;
    const end = start + this.pageSize;
    const gridRowsData = this.processedData.slice(start, end);
    this.dataToUse = {
      ...this.dataToUse,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      processedData: gridRowsData,
    };
  }
}
